import { Guid, IApiLink } from "@/types"

export interface ICreateLabelCategoryDto {
    name: string
}

export interface ICreateLabelCategory {
    dto: ICreateLabelCategoryDto
    createLink: IApiLink
}

export interface IGetLabelCategoryDto {
    id: Guid
    name: string
}

export default class LabelCategory {
    id: Guid
    name: string

    constructor(dto: IGetLabelCategoryDto) {
        this.id = dto.id
        this.name = dto.name
    }
}
